import styles from "gatsby-theme-docz/src/theme/styles";

styles.blockquote.fontStyle = "normal";

styles.Container.maxWidth = 1100;

// styles.Container.overflow = "auto";

export default styles;
